import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { useTests } from 'modules/dtm';
import { useOrderTest } from 'modules/dtm-test';
import { formatSubject, globalConst, isEmptyArr } from 'modules/global';

import { Card, EmptyData, Visible } from 'components';

import { Header } from './header';
import TestCardSkeleton from './test-card-skeleton';

export const TestMain = () => {
  const t = useTranslations();
  const { query } = useRouter();
  const blockId = (query?.test as string)?.split('-')[0];
  const { tests, isLoading } = useTests({ blockId });
  const { mutate, isLoading: isStartingTest } = useOrderTest();

  const onStartTest = (testId: number) => {
    mutate({ collection_id: testId });
  };

  return (
    <div className="mt-7">
      <Header subject={query?.test as string} />
      <div className="mt-7 grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        <Visible
          if={isLoading}
          else={
            <Visible
              if={isEmptyArr(tests)}
              else={tests?.map((test, index) => (
                <Card
                  key={test?.id}
                  year={test?.year}
                  testId={test?.id}
                  score={test?.ball}
                  rating={test?.rating}
                  onStart={onStartTest}
                  testIndex={index + 1}
                  isSaved={test?.is_saved}
                  language={test?.language}
                  isPremium={test?.is_premium}
                  isStartingTest={isStartingTest}
                />
              ))}
            >
              <div className="col-span-4">
                <EmptyData
                  title={t('hozircha_testlar_mavjud_emas')}
                  desc={t.rich('subject_fani_boyicha_testlarni_ishlab_turishingiz_mumkin', {
                    link: chunks => (
                      <Link href={`${globalConst.pageNames.TOPIC_TEST}/${query?.subject}`} className="text-blue-500">
                        {chunks}
                      </Link>
                    ),
                    subject: formatSubject(query?.subject as string)
                  })}
                />
              </div>
            </Visible>
          }
        >
          {Array.from({ length: 4 }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <TestCardSkeleton key={index} />
          ))}
        </Visible>
      </div>
    </div>
  );
};
